module.exports = __webpack_public_path__ + "img/csss-bordeau.eaac5353.png";